import React, { useEffect, useState } from 'react';
import './Stlye.css';
import { NavLink } from 'react-router-dom';
import {Container, Row, Col} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Petroleumbanner2 from '../src/images/cairns_bg.webp';
// import Petroleumbanner from '../src/images/data-banner.jpg';
// import DataCons1213 from "../src/images/data_cons_1213.jpg";
// import Data222 from "../src/images/data_222.jpg";
// import Data224 from "../src/images/data_223.jpg";
import Data225 from "../src/images/data_225.webp";
import Data121346 from "../src/images/data__121346.webp";
import faq1 from '../src/images/faq_banner.webp';
import AngelCairnsBg from "../src/images/angel_cairns_bg.webp";
import Angel1 from "../src/images/angel_1.webp";
import WhyChhoseBg from "../src/images/why_choose_bg.webp";
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import MetaTags from './MetaTags';
function LandingPageBrisbaneAngelInvestor() {

    const [openIndex, setOpenIndex] = useState(null);
    const faqData = [
        {
            question: 'What are the benefits of working with an angel investor?',
            answer: 'Angel investors provide not only funding but also mentorship, industry connections, and strategic advice, which can be invaluable for the growth of your startup.',
        },
        {
            question: 'How can your consulting services increase my chances of securing investment?',
            answer: "We help you develop a strong business plan and pitch deck, and connect you with our network of investors, enhancing your appeal and chances of securing funding.",
        },
        {
            question: 'What types of startups are most attractive to angel investors in Brisbane?',
            answer: "Startups with innovative solutions, scalable business models, and strong market potential are particularly attractive to angel investors in Brisbane.",
        },
        {
            question: 'What should I include in my pitch to angel investors?',
            answer: 'Your pitch should include a clear business plan, market analysis, financial projections, and a compelling value proposition that highlights your startup’s potential.',
        },
        {
            question: 'What is the typical timeline for securing angel investment?',
            answer: "The timeline can vary but generally involves preparing your pitch, presenting to investors, undergoing due diligence, and finalizing the investment agreement over a period of several months.",
        },
        // Add more FAQ items as needed
    ];
    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <>
            <section className="innr_banner" style={{
                backgroundImage: `url(${AngelCairnsBg})`,
                backgroundPosition:'bottom'
            }}>
                 <MetaTags
        title="Angel Investor Services Brisbane | Startup Investment & Funding Match"
        description="Connect with Brisbane’s angel investor ecosystem. We help startups secure smart capital and support investors with due diligence, pitch review, and strategic deal structuring."
        // keywords="Angel Investor Service Cairns"
        identifyUrl="https://smartresourcesqld.com.au/operations/angel-investor/brisbane"
        DCTitle="Angel Investor Services Brisbane | Startup Investment & Funding Match"
        DCDescription="Connect with Brisbane’s angel investor ecosystem. We help startups secure smart capital and support investors with due diligence, pitch review, and strategic deal structuring."
        DCSubject="Angel Investor Service Brisbane"
        Canonical="https://smartresourcesqld.com.au/operations/angel-investor/brisbane"
        ogImage={AngelCairnsBg}
        ogTitle="Angel Investor Services Brisbane | Startup Investment & Funding Match"
        ogDescription="Connect with Brisbane’s angel investor ecosystem. We help startups secure smart capital and support investors with due diligence, pitch review, and strategic deal structuring."
        ogUrl="https://smartresourcesqld.com.au/operations/angel-investor/brisbane"
      />

        
                <div className="page_title_innr" data-aos="fade-down">
                    <div className="page_title">Angel Investor Consulting in Brisbane</div>
                    <ul className="bread_crumb">
                        <li><NavLink to="/">Home</NavLink></li>
                        <li><NavLink to="/operations">Operations</NavLink></li>
                        <li><NavLink to="/operations/angel-investor">Angel Investor</NavLink></li>
                        <li>Brisbane</li>
                    </ul>
                </div>
            </section>

            <section className='middle_partts'>
                <section className="pricing">
                    <div className="servinnng_middle">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="global_left serv_innr_heading" data-aos="fade-up">
                                        <h1>Angel Investor Services in Brisbane Empowering Startup Growth & Innovation</h1>
                                        <p>Brisbane’s thriving startup scene is attracting a growing number of angel investors who are eager to fund innovative businesses with high-growth potential. Our angel investor consulting services in Brisbane are designed to bridge the gap between ambitious entrepreneurs and forward-thinking investors, ensuring strategic partnerships that benefit both parties.</p>
                                        <p>Whether you're an investor seeking promising ventures or a founder searching for smart capital, we provide the expertise to facilitate meaningful, growth-focused investment relationships.</p>

                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="global_left serv_innr_heading" data-aos="fade-up">
                                        <h1>Supporting Brisbane’s Startup and Investment Ecosystem</h1>
                                        <p>With government support, coworking spaces, accelerators, and a growing talent pool, Brisbane has become a top destination for startups in Australia. Our angel investor services are built to navigate this landscape with precision and purpose.</p>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="discuss-seo data_price_bg good_investor_2">
                        <div className="container">
                            <div className="row discuss-ppc-seo">
                                <h2 style={{ color: 'white' }}>
                                    Reach out today to learn how we can help you attract angel investors in Brisbane!
                                </h2>
                                <div className="button-ppc-new">
                                    <NavLink className="btn-trans" to="/contact-us" onClick={() => window.scrollTo(0, 0)}>Contact Us</NavLink>
                                    {/* <a className="btn-trans" href="https://www.dubseo.co.uk/seo-services-packages-and-prices-london">Check Out Our Price</a> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="include_services">
                        <div className='include_service_innr'>
                            <Container>
                                <Row>

                                    <Col lg="4" md="6" sm="12">
                                        <div className='include_img' data-aos='fade-right'><img src={Angel1} alt="" className="img-fluid" /></div>
                                    </Col>

                                    <Col lg="8" md="6" sm="12">
                                        <div className='include_text' data-aos='fade-left'>
                                            <h3>Our Angel Investment Services Include:</h3>
                                            {/* <img src={line} alt="Your Image" /> */}
                                            <div className='pf'>
                                                <ul>
                                                    <li>
                                                        <strong>Startup Evaluation & Due Diligence:    </strong>We assess early-stage companies on product viability, scalability, leadership, and market fit.
                                                    </li>
                                                    <li>
                                                        <strong>Investor Matchmaking:    </strong>Connect high-potential Brisbane startups with suitable angel investors aligned with their vision.
                                                    </li>
                                                    <li>
                                                        <strong>Pitch Deck & Business Plan Advisory:  </strong>Support startups in crafting compelling investor materials and financial projections.
                                                    </li>
                                                    <li>
                                                        <strong>Deal Structuring & Term Sheets:  </strong>Assist with equity negotiations, SAFE notes, and investment terms that protect investor interests.
                                                    </li>
                                                    <li>
                                                        <strong>Post-Investment Support:  </strong>Help monitor performance, track KPIs, and manage stakeholder expectations after funding.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Col>

                                </Row>

                            </Container>


                        </div>
                        <div className='include_service_innr'>
                            <Container>
                                <Row>
                                    <Col lg="8" md="6" sm="12" className='include_textpartts'>
                                        <div className='include_text' data-aos='fade-left'>
                                            <h3>Why Work With Us? </h3>
                                            {/* <img src={line} alt="Your Image" /> */}
                                            <div className='pf'>
                                                <ul>
                                                    <li>
                                                        Deep understanding of Brisbane’s innovation ecosystem.
                                                    </li>
                                                    <li>
                                                        Access to a vetted network of local and global angel investors.
                                                    </li>

                                                    <li>
                                                        Experience facilitating high-return early-stage investments.
                                                    </li>
                                                    <li>
                                                        End-to-end consulting for both founders and investors.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Col>

                                    <Col lg="4" md="6" sm="12" className='include_imgpartts'>
                                        <div className='include_img right' data-aos='fade-left'>
                                            <img src={WhyChhoseBg} alt="" />
                                        </div>
                                    </Col>
                                </Row>
                            </Container>

                        </div>
                        <div className="servinnng_middle">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="global_left serv_innr_heading" data-aos="fade-up">
                                            <h2>Conclusion</h2>
                                            <p>Investing in early-stage ventures is about more than capital—it’s about strategic partnership. Our <NavLink to="/operations/angel-investor" onClick={() => window.scrollTo(0, 0)}>angel investor services</NavLink> in Brisbane empower both startups and investors to collaborate with confidence and clarity. Whether you're an entrepreneur ready to scale or an investor looking to diversify your portfolio with high-growth opportunities, we help ensure every investment decision is guided by data, diligence, and foresight. Let's build Brisbane’s future, together.</p>

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>



                        <div className="faqContainer" data-aos="fade-up">
                            <Container>
                                <Row>
                                    <Col lg="8" md="6" sm="12" className='accordion_left'>
                                        <div className="accordion">
                                            <h1>Frequently Asked Questions</h1>
                                            {faqData.map((item, index) => (
                                                <div key={index} className="accordion-item">
                                                    <div className="accordion-question" onClick={() => toggleAccordion(index)}>
                                                        <h2>{item.question}</h2>
                                                        {openIndex === index ? <AiOutlineUp /> : <AiOutlineDown />}
                                                    </div>
                                                    {openIndex === index && <div style={{ fontSize: '18px' }} className="accordion-answer">{item.answer}</div>}
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col lg="4" md="6" sm="12" className='accordion_right'>
                                        <div className="faq_Image">
                                            {/* Place your image here */}
                                            <div style={{ position: 'relative' }} className='faq_data'>
                                                <img
                                                    src={faq1}
                                                    className="img-fluid"
                                                    alt=""
                                                />

                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </section>

                </section>
            </section>
        </>
    );
}

export default LandingPageBrisbaneAngelInvestor;